import { HideButtonContext } from "@/shared/hooks";
import { ReactNode } from "react";

interface HideButtonProps {
    hidden?: boolean;
    children: ReactNode;
}

export function HideButtonProvider({ hidden = true, children }: HideButtonProps) {
    return <HideButtonContext value={hidden}>{children}</HideButtonContext>;
}
